import { computedFn } from 'mobx-utils';

/** Encode the cells as a CSV string. */
export const csvToString = computedFn((rows: readonly string[][]): string => {
  const maxColumns = Math.max(...rows.map((row) => row.length));
  return rows
    .map(
      (row) =>
        row.map(escapeCell).join(',') + repeat(maxColumns - rows.length, ','),
    )
    .join('\n');
});

function escapeCell(s: string): string {
  return '"' + s.replace(/"/g, '""') + '"';
}

function repeat(n: number, s: string): string {
  let result = '';
  for (let i = 0; i < n; i++) {
    result += s;
  }
  return result;
}

/** Clean a string to be used as part of a filename. */
export function filenameify(s: string | undefined, fallback: string): string {
  if (!s) return fallback;
  const cleaned = s
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace('/-$/', '')
    .replace(/^-/, '');
  return cleaned || fallback;
}
